var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.32048 12V5.45455H8.32616V12H7.32048ZM7.83184 4.36364C7.63582 4.36364 7.46679 4.29688 7.32474 4.16335C7.18554 4.02983 7.11593 3.86932 7.11593 3.68182C7.11593 3.49432 7.18554 3.33381 7.32474 3.20028C7.46679 3.06676 7.63582 3 7.83184 3C8.02787 3 8.19548 3.06676 8.33468 3.20028C8.47673 3.33381 8.54775 3.49432 8.54775 3.68182C8.54775 3.86932 8.47673 4.02983 8.33468 4.16335C8.19548 4.29688 8.02787 4.36364 7.83184 4.36364Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconGray);
export default __webpack_public_path__ + "static/media/InfoIcon-gray.122e7a1d7a74e7f9c886496781d0c139.svg";
export { ForwardRef as ReactComponent };